<error-alert>
  <div class="alert alert-danger alert-dismissible fade show" role="alert" if={ props.message }>
    <div class="d-flex align-items-start">
      <i class="bi bi-exclamation-triangle-fill me-2 flex-shrink-0" style="font-size: 1.25rem;"></i>
      <div class="flex-grow-1">
        <strong if={ props.title }>{ props.title }</strong>
        <p class="mb-0">{ props.message }</p>

        <!-- Botón de reintentar si se proporciona la función -->
        <button
          if={ props.onretry }
          type="button"
          class="btn btn-sm btn-outline-danger mt-2"
          onclick={ handleRetry }>
          <i class="bi bi-arrow-repeat me-1"></i> Reintentar
        </button>
      </div>

      <!-- Botón de cerrar si se proporciona la función -->
      <button
        if={ props.ondismiss }
        type="button"
        class="btn-close"
        aria-label="Close"
        onclick={ handleDismiss }>
      </button>
    </div>
  </div>

  <script>
    export default {
      handleRetry(e) {
        if (this.props.onretry) {
          this.props.onretry(e);
        }
      },

      handleDismiss(e) {
        if (this.props.ondismiss) {
          this.props.ondismiss(e);
        }
      }
    }
  </script>

  <style>
    error-alert .alert {
      margin-bottom: 1.5rem;
    }

    error-alert .alert strong {
      display: block;
      margin-bottom: 0.25rem;
    }

    error-alert .bi-exclamation-triangle-fill {
      color: #dc3545;
      margin-top: 0.125rem;
    }
  </style>
</error-alert>
